import styled from 'styled-components';

export const Card = styled.section`
  background-color: ${({ theme }) => theme.colors.light.hex()};
  box-shadow: ${({ theme }) => theme.shadows.md};
  width: 100%;
`;
